import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  signInWithPopup, 
  signInWithRedirect,
  GoogleAuthProvider,
  getRedirectResult,
  signOut,
  type User 
} from 'firebase/auth';
import { auth } from '../config';
import { createUserProfile } from './user.service';

const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');

export class AuthService {
  static async loginWithEmail(email: string, password: string): Promise<User> {
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    return user;
  }

  static async registerWithEmail(email: string, password: string, name: string): Promise<User> {
    const { user } = await createUserWithEmailAndPassword(auth, email, password);
    await createUserProfile(user, { name });
    return user;
  }

  static async loginWithGoogle(): Promise<User | null> {
    try {
      // First try popup
      try {
        const result = await signInWithPopup(auth, googleProvider);
        if (result.user) {
          await createUserProfile(result.user);
          return result.user;
        }
      } catch (error: any) {
        // If popup blocked, fallback to redirect
        if (error.code === 'auth/popup-blocked') {
          await signInWithRedirect(auth, googleProvider);
          return null; // User will be redirected
        }
        throw error;
      }
      
      // Check for redirect result
      const result = await getRedirectResult(auth);
      if (result?.user) {
        await createUserProfile(result.user);
        return result.user;
      }
      
      return null;
    } catch (error) {
      console.error('Google login error:', error);
      throw error;
    }
  }

  static async logout(): Promise<void> {
    await signOut(auth);
  }
}